import "./Features.css";
import {
  FaMapMarkerAlt,
  FaBuilding,
  FaChartLine,
  FaShieldAlt,
  FaGem,
} from "react-icons/fa";

function Features() {
  return (
    <section className="features"id="caracteristicas">

      <div className="feature">

        <FaMapMarkerAlt className="icon"/>

        <h3>Excelente Ubicación</h3>

      </div>

      <div className="feature">

        <FaBuilding className="icon"/>

        <h3>Diseño Moderno</h3>

      </div>

      <div className="feature">

        <FaChartLine className="icon"/>

        <h3>Alta Valorización</h3>

      </div>

      <div className="feature">

        <FaShieldAlt className="icon"/>

        <h3>Seguridad 24/7</h3>

      </div>

      <div className="feature">

        <FaGem className="icon"/>

        <h3>Materiales Premium</h3>

      </div>

    </section>
  );
}

export default Features;